<template>
    <div class="flow-wrap">
        <div class="info-tab">
            <div class="info-wrap" v-if="objBaseInfo.process_name">
                <div class="title">
                    <div class="name">{{objBaseInfo.process_name}}</div>
                    <div class="num">{{objBaseInfo.wokor_name}}</div>
                </div>
                <div class="date">施工时间：{{objBaseInfo.new_actualstartedon}} {{objBaseInfo.new_actualfinishedon}}</div>
                <img class="state-img" v-if="objBaseInfo.new_status==1" src="@/assets/images/archives/dispatched.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==2" src="@/assets/images/archives/dispatch.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==3" src="@/assets/images/archives/responded.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==4" src="@/assets/images/archives/completed.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==5" src="@/assets/images/archives/reviewed.png" alt="">
<!--                <img class="state-img" v-if="objBaseInfo.new_status==6" src="@/assets/images/archives/completed.png" alt="">-->
<!--                <img class="state-img" v-if="objBaseInfo.new_status==7" src="@/assets/images/archives/completed.png" alt="">-->
                <img class="state-img" v-if="objBaseInfo.new_status==91" src="@/assets/images/archives/qualified.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==92" src="@/assets/images/archives/unqualified.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==93" src="@/assets/images/archives/modifying.png" alt="">
                <img class="state-img" v-if="objBaseInfo.new_status==94" src="@/assets/images/archives/modified.png" alt="">
            </div>
            <div class="tab-wrap" v-if="arrBasicInfo&&arrBasicInfo.length">
                <template v-for="(item,index) in arrTab">
                    <div class="tab-item" :class="{'tab-item-active':index==nTabCurrent}" @click="tabChange(index)">{{item}}</div>
                </template>
            </div>
        </div>
        <div class="content-info">
            <transition-group name="hello" appear>
                <div class="tab-content" v-show="nTabCurrent==0" key="0">
                    <div class="basic-content">
                        <template v-for="item in arrBasicInfo">
                            <div class="item">
                                <div class="title-wrap">
                                    <div class="title">{{item.title}}</div>
                                </div>
                                <div class="data-wrap">
                                    <template v-for="(it,itx) in item.content">
                                        <div class="lable-wrap" :style="{'background':(itx%2)?'#ffffff':'#F9F9FB'}">
                                            <div class="lable">{{it.label}}：</div>
                                            <div class="value">{{it.value}}</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tab-content" v-show="nTabCurrent==1" key="1">
                    <div class="supervision-content" v-if="isSupervision">
                        <template v-for="item in arrFeedback">
                            <div class="item">
                                <div class="title">{{item.title}}</div>
                                <div class="step-wrap">
                                    <template v-for="it in item.content">
                                        <div class="step-item">
                                            <div class="title-wrap">
                                                <div class="title">{{it.segmentation_name}}</div>
                                            </div>
                                            <div class="desc">*{{it.title}}</div>
                                            <div class="tips">{{it.new_memo}}</div>
                                            <div class="standard" v-if="it.standard_photo">
                                                <div class="title">施工标准样例图</div>
                                                <div class="img-wrap">
                                                    <img :src="it.standard_photo" :preview="it.title"  alt="">
                                                </div>
                                            </div>
                                            <div class="live" v-if="it.photos&&it.photos.length">
                                                <template v-for="(img,imgItx) in it.photos">
                                                    <div class="live-img">
                                                        <img :src="img" :preview="imgItx+'a'"  alt="">
                                                    </div>
                                                </template>
                                            </div>
                                            <div class="question">
                                                <template v-for="qIt in it.acceptance">
                                                    <div class="question-item" v-if="qIt.new_ifblank ==0">
                                                        <div class="title">{{qIt.title}}</div>
                                                        <div class="answer-wrap">
                                                            <template v-for="an in qIt.options">
                                                                <p>
                                                                    <span v-if="qIt.new_score<0.00" :style="{'color':(qIt.new_score<0.00 && an.option_val==qIt.checked)?'red':'#999999'}">{{an.option_name}}</span>
                                                                    <span  v-if="qIt.new_score>=0.00" :style="{'color':(qIt.new_score>=0.00 && an.option_val==qIt.checked)?'#000000':'#999999'}">{{an.option_name}}</span>
                                                                    <img v-if="(an.option_val==qIt.checked) && qIt.new_score>=0.00" src="@/assets/images/archives/workOrder/Group.png" alt="">
                                                                    <img  v-if="(an.option_val==qIt.checked) && qIt.new_score<0.00" src="@/assets/images/archives/workOrder/1Group.png" alt="">
                                                                </p>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="question-item" v-if="qIt.new_ifblank ==1">
                                                        <div class="title">{{qIt.title}}</div>
                                                        <div class="answer-wrap">
                                                            {{qIt.result}}
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="worker-content" v-else>
                        <template v-for="(item,index) in arrFeedbackWorder">
                            <div class="item">
                                <div class="title-wrap">
                                    <div class="title">{{item.title}}</div>
                                    <div class="live">
                                        <template v-for="(img,imgItx) in item.content">
                                            <div class="live-img">
                                                <img :preview="index" @error="imgOnerror($event)" :src="img" alt="">
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tab-content" v-show="nTabCurrent==2" key="2">
                    <div class="attendance-content">
                        <div class="title-wrap">
                            <div class="title">{{arrRecord.title}}</div>
                        </div>
                        <div class="record-wrap">
                            <template v-for="(item,index) in arrRecord.content">
                                <div class="record-item">
                                    <div class="record-day">
                                        <div class="day-top">
                                            <div class="day-left">
                                                <img src="@/assets/images/archives/workOrder/time-icon.png" alt="">
                                            </div>
                                            <div class="day-right">{{item.date}}</div>
                                        </div>
                                        <div class="day-bottom"><p></p></div>
                                    </div>
                                    <template v-for="(it,itx) in item.content">
                                        <div class="resord-date">
                                            <div class="date-top">
                                                <div class="date-left">{{it.time}}</div>
                                                <div class="date-right">{{it.content.title}}</div>
                                            </div>
                                            <div class="date-bottom">
                                                <div class="line-left"><p v-if="!((index==arrRecord.length-1)&&(itx==item.arrDate.length-1))"></p></div>
                                                <div class="text" v-if="it.content.address">
                                                    <div class="text-content">{{it.content.address}}</div>
                                                    <div class="img-wrap" v-if="false">
                                                        <template v-for="img in it.img">
                                                            <div class="img-item"></div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>
<script>
import {baseInfo, checkInfo, workInfo} from "@/js/archives/progress";

export default {
    data(){
        return{
            isSupervision:false,//是否是监理验收
            nTabCurrent:0,
            arrTab:['基本信息','过程反馈','考勤记录'],
            arrBasicInfo:[],//tab-基本信息
            arrFeedback:[],//tab-反馈-验收
            arrFeedbackWorder:[],//tab-反馈-施工
            arrRecord:{},//tab-考勤记录
            objBaseInfo:{},//头部基本信息
            defaultImg: require('@/assets/images/case_detail_def.png')
        }
    },
    created(){
        this.isSupervision = (this.$route.query.isSupervision==='false' || this.$route.query.isSupervision===false)?false:true
        console.log(this.isSupervision,this.$route.query.isSupervision,'======')
        this.getBaseInfoJl()//获取基本信息
        if(this.isSupervision){
            console.log(this.isSupervision,'验收')
            // 监理验收
            this.getCheckInfo('basic')//默认获取base信息
        }else{
            console.log(this.isSupervision,'施工')
            // 个人工单-施工
            this.getWorkInfo('basic')//默认获取base信息
        }
    },
    methods:{
        // 切换标签
        tabChange(index){
            if(this.nTabCurrent!=index && this.isSupervision){
                console.log(this.isSupervision,'验收')
                if(index==0){
                    this.getCheckInfo('basic')
                }else if(index==1) {
                    this.getCheckInfo('progress')
                }else if(index==2){
                    this.getCheckInfo('attendance')
                }
            }else if(this.nTabCurrent!=index && !this.isSupervision){
                console.log(this.isSupervision,'施工')
                if(index==0){
                    this.getWorkInfo('basic')
                }else if(index==1) {
                    this.getWorkInfo('progress')
                }else if(index==2){
                    this.getWorkInfo('attendance')
                }
            }
            this.nTabCurrent=index
        },
        // 基本信息
        getBaseInfoJl(){
            this.$store.commit("loadSwitch", true);
            baseInfo({workorder_id:this.$route.query.workorderId || 'e7e55d57-5e39-43c6-ab44-c65d4caa8526'}).then(res=>{
                this.$store.commit("loadSwitch", false);
                let {data:{data:{result}}} =res
                this.objBaseInfo=result
            })
        },
        // 相关tab信息-监理验收
        getCheckInfo(tab){
            this.$store.commit("loadSwitch", true);
            checkInfo({workorder_id:this.$route.query.workorderId || '4d9cb072-2bef-4742-b246-66ab82eac4fd',tab:tab}).then(res=>{
                this.$store.commit("loadSwitch", false);
                let {data:{data:{result}}} =res
                if(this.nTabCurrent==0){
                    this.arrBasicInfo=result
                }else if(this.nTabCurrent==1){
                    this.arrFeedback=result
                    setTimeout(()=>{
                        this.$previewRefresh()
                    },300)
                }else if(this.nTabCurrent==2){
                    this.arrRecord=result
                    console.log(this.arrRecord,'考勤监理验收')
                }
            })
        },
        // 相关tab信息-施工
        getWorkInfo(tab){
            this.$store.commit("loadSwitch", true);
            workInfo({workorder_id:this.$route.query.workorderId || '63050812-4850-445e-81be-fcf39afd4139',tab:tab}).then(res=>{
                this.$store.commit("loadSwitch", false);
                let {data:{data:{result}}} =res
                if(this.nTabCurrent==0){
                    this.arrBasicInfo=result
                }else if(this.nTabCurrent==1){
                    this.arrFeedbackWorder=result
                    setTimeout(()=>{
                        this.$previewRefresh()
                    },300)
                }else if(this.nTabCurrent==2){
                    this.arrRecord=result
                    console.log(result,'考勤-验收')
                }
            })
        },
        imgOnerror(event) {
            let img = event.srcElement
            img.src = this.defaultImg
            img.onerror = null // 防止闪图
        },
    }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar{display:none}
/* 进入的起点、离开的终点 */
.hello-enter,
.hello-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}
.hello-enter-active,
.hello-leave-active {
    transition: 0.4s linear;
}
/* 进入的终点、离开的起点 */
.hello-enter-to,
.hello-leave {
    opacity: 1;
    transform: translateX(0);
}
.flow-wrap{
    width: 100vw;
    height: 100vh;
    background: #F9F9FB;
    display: flex;
    flex-direction:column;
    .info-tab{
        padding: 38px 32px 16px 32px;
        //margin-bottom: 16px;
        background: #F3F6FF;
        .info-wrap{
            position: relative;
            .title{
                display: flex;
                align-items: center;
                .name{
                    font-size: 36px;
                    font-weight: 600;
                    color: #333333;
                    line-height: 42px;
                }
                .num{
                    font-size: 24px;
                    font-weight: 400;
                    color: #555555;
                    line-height: 28px;
                    margin-left: 16px;
                }

            }
            .date{
                font-size: 24px;
                font-weight: 400;
                color: #555555;
                margin-top: 16px;
                line-height: 28px;
            }
            .state-img{
                position: absolute;
                top: 0px;
                right:0px;
                width: 161px;
                height: 153px;
            }
        }
        .tab-wrap{
            width: 100%;
            height: 80px;
            background: #FFFFFF;
            border-radius: 16px 16px 16px 16px;
            margin-top: 84px;
            display: flex;
            padding: 0 88px;
            justify-content: space-between;
            .tab-item{
                font-size: 24px;
                font-weight: 400;
                color: #A3A3A3;
                line-height: 80px;
            }
            .tab-item-active{
                font-weight: 600;
                color: #0D53FC;
                position: relative;
                &:after{
                    width: 100%;
                    height: 4px;
                    content:'';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background:#0D53FC;
                }
            }
        }
    }
    .content-info{
        width: 100%;
        flex: 1;
        padding: 0px 32px 32px 32px;
        overflow-y: scroll;
        background:linear-gradient(to bottom,#F3F6FF 0%,#F3F6FF 10%,#F9F9FB 10.01%,#F9F9FB 100%);
        .tab-content{
            width: 100%;
            .basic-content{
                width: 100%;
                .item{
                    margin-bottom: 16px;
                    width: 100%;
                    background: #FFFFFF;
                    border-radius: 16px 16px 16px 16px;
                    overflow: hidden;
                    .title-wrap{
                        padding: 32px 44px;
                        .title {
                            font-size: 24px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 28px;
                            border-left: 5px solid #0D53FC;
                            padding-left: 16px;
                        }
                    }
                    .data-wrap{
                        .lable-wrap{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width:100%;
                            height: 80px;
                            background: #F9F9FB;
                            padding: 0 48px;
                            .lable{
                                font-size: 24px;
                                color: #999999;
                            }
                            .value{
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                            }
                        }
                    }
                }
            }
            .supervision-content{
                .item{
                    width: 100%;
                    border-radius: 16px;
                    background: #ffffff;
                    padding: 48px 44px;
                    margin-bottom: 16px;
                    .title {
                            font-size: 28px;
                            font-weight: 600;
                            color: #333333;
                            line-height: 33px;
                    }
                    .step-wrap{
                        margin-top: 32px;
                        .step-item{
                            padding-bottom: 64px;
                            border-bottom: 2px solid #F5F5F5;
                            margin-bottom: 48px;
                            &:last-child{
                                margin-bottom: 0;
                                border-bottom:0;
                                padding-bottom:0;
                            }
                            .title-wrap{
                                .title {
                                    font-size: 24px;
                                    color: #333333;
                                    line-height: 28px;
                                    border-left: 5px solid #0D53FC;
                                    padding-left: 16px;
                                }
                            }
                            .desc{
                                font-size: 24px;
                                font-weight: 400;
                                color: #999999;
                                line-height: 28px;
                                margin:20px 0 16px 0;
                            }
                            .tips{
                                font-size: 20px;
                                font-weight: 500;
                                color: #E95859;
                                line-height: 23px;
                                text-indent: 10px;
                            }
                            .standard{
                                background: #F9F9FB;
                                border-radius: 16px;
                                overflow: hidden;
                                margin-top: 32px;
                                .title{
                                    width: 100%;
                                    height: 64px;
                                    background: linear-gradient(126deg, rgba(13, 83, 252, 0.5) 0%, rgba(13,83,252,0) 100%);
                                    padding-left: 20px;
                                    line-height: 64px;
                                    font-size: 24px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }
                                .img-wrap{
                                    overflow: hidden;
                                    width: 100%;
                                    height: 274px;
                                    background: #F9F9FB;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                            }
                            .live{
                                overflow-x: scroll;
                                margin-top: 16px;
                                white-space: nowrap;
                                .live-img{
                                    display: inline-block;
                                    width: 160px;
                                    height: 160px;
                                    background: #F9F9FB;
                                    border-radius: 16px;
                                    margin-right: 16px;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                            }
                            .question{
                                margin-top: 64px;
                                .question-item{
                                    margin-bottom: 54px;
                                    &:last-child{
                                        margin-bottom: 0;
                                    }
                                    .title{
                                        font-size: 24px;
                                        font-weight: 400;
                                        color: #999999;
                                        margin-bottom: 22px;
                                        line-height: 28px;
                                    }
                                    .answer-wrap{
                                        display: flex;
                                        p{
                                            width: 30%;
                                            font-size: 24px;
                                            font-weight: 400;
                                            color: #999999;
                                            line-height: 28px;
                                            display: flex;
                                            align-items: center;
                                            img{
                                                width: 32px;
                                                height: 32px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .worker-content{
                .item{
                    width: 100%;
                    height: 338px;
                    background: #FFFFFF;
                    border-radius: 16px;
                    padding: 32px 44px;
                    margin-bottom: 16px;
                    .title-wrap{
                        .title {
                            font-size: 24px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 28px;
                            border-left: 5px solid #0D53FC;
                            padding-left: 16px;
                        }
                        .live{
                            margin-top: 48px;
                            overflow-x: scroll;
                            white-space: nowrap;
                            .live-img{
                                display: inline-block;
                                width: 160px;
                                height: 160px;
                                background: #F9F9FB;
                                border-radius: 16px;
                                margin-right: 16px;
                                img{
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }
                        }
                    }
                }
            }
            .attendance-content{
                width: 100%;
                background: #FFFFFF;
                border-radius: 16px;
                padding: 32px 44px;
                .title-wrap{
                    margin-bottom: 66px;
                    .title {
                        font-size: 24px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 28px;
                        border-left: 5px solid #0D53FC;
                        padding-left: 16px;
                    }
                }
                .record-wrap{
                    .record-item{
                        .record-day{
                            .day-top{
                                display: flex;
                                align-items: center;
                                .day-left{
                                    width: 64px;
                                    img{
                                        width: 64px;
                                        height: 64px;
                                    }
                                }
                                .day-right{
                                    padding-left: 30px;
                                    font-size: 28px;
                                    font-weight: 600;
                                    color: #333333;
                                }
                            }
                            .day-bottom{
                                width: 64px;
                                height: 80px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                p{
                                    width: 0px;
                                    height: 100%;
                                    border-left: 1px dashed #EEEEEE;
                                }
                            }
                        }
                        .resord-date{
                            .date-top{
                                display: flex;
                                align-items: center;
                                .date-left{
                                    width: 64px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000000;
                                }
                                .date-right{
                                    padding-left: 30px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000000;
                                }
                            }
                            .date-bottom{
                                display: flex;
                                .line-left{
                                    width: 64px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    p{
                                        width: 0px;
                                        height: 100%;
                                        border-left: 1px dashed #EEEEEE;
                                    }
                                }
                                .text{
                                    flex: 1;
                                    font-size: 24px;
                                    font-weight: 400;
                                    padding-left: 30px;
                                    color: #999999;
                                    padding-bottom: 50px;
                                }
                                .text-content{
                                    margin-top: 10px;
                                }
                                .img-wrap{
                                    display: flex;
                                    flex-wrap: wrap;
                                    margin-top: 16px;
                                    .img-item{
                                        width: 160px;
                                        height: 160px;
                                        background: #F9F9FB;
                                        border-radius: 16px;
                                        margin-right: 12px;
                                        margin-bottom: 12px;
                                        &:nth-child(3n){
                                            margin-right: 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
